export const ColorStyle = {
  default: '#1a518a',
  danger: '#ff0000',
  focus: '#5087c0',
};
